var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconExternalLink = function SvgIconExternalLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1F1F1F",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.375,
    d: "M10.5 6.375H6.375A1.375 1.375 0 0 0 5 7.75v6.875A1.375 1.375 0 0 0 6.375 16h6.875a1.375 1.375 0 0 0 1.375-1.375V10.5m-4.812.688L16 5m0 0h-3.437M16 5v3.438"
  })));
};
export default SvgIconExternalLink;